/*=========================================
	++ common.js ++ Ver.1.6.1
	Last update 2020.9.10
==========================================*/
/*
* 2020  9/10 全体を一新
* 2019  5/ 7  *object-fit-images 追加
* 2018 11/20  *ブラウザ判定処理を一新
* 2018 10/25  *jQuery 3系 に対応

*/

'usestrict';

//=====================================
//	Detecting Browser & Device Ver.1.4.2
//============================================

//++++++++++++ モバイル/タブレット/ブラウザ判定処理 ++++++++++++

//ブラウザ/デバイス 種別
var isMobile = false,
	isTablet = false,
	isRetina = false,
	isMobileTablet = false,
	isAndroid = false;

//モバイル　タブレット　判定
//https://w3g.jp/blog/js_browser_sniffing2015
var _ua = (function (u) {
	return {
		Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) ||
			u.indexOf("ipad") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
			u.indexOf("kindle") != -1 ||
			u.indexOf("silk") != -1 ||
			u.indexOf("playbook") != -1,
		Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
			u.indexOf("iphone") != -1 ||
			u.indexOf("ipod") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) |
			u.indexOf("blackberry") != -1
	};
})(window.navigator.userAgent.toLowerCase());

//モバイル
if (_ua.Mobile) {
	isMobile = true;
	isMobileTablet = true;
}
//タブレット
if (_ua.Tablet) {
	isTablet = true;
	isMobileTablet = true;
}

//Retina Display 判定
if (window.retina || window.devicePixelRatio > 1) {
	isRetina = true;
}

//Android 判定
if (/android[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
	isAndroid = true;
}


//============================================
//	デバイス　ブラウザ別の処理
//============================================

//++++++++++++ モバイル/タブレット クラス追加 ++++++++++++

$(function () {
	if (isMobile) {
		//HTMLにclass isMobileを追加
		$('html').addClass('isMobile');
		$('html').addClass('isMobileTablet');
	} else if (isTablet) {
		//HTMLにclass isTabletを追加
		$('html').addClass('isTablet');
		$('html').addClass('isMobileTablet');
	}
	//Retina Display isRetina クラス追加
	if (isRetina) {
		$('html').addClass('isRetina');
	}
});




//============================================
//	汎用スクリプト 
//============================================


//++++++ Copyright ++++++
// Copyright <span class="copyYear">&copy;</span>

$(function () {
	let date = new Date();
	let copyYear = date.getFullYear();
	copyYear = '&copy; ' + copyYear;
	$('.copyYear').html(copyYear);
});





$(function () {
	$(".menubtn").click(function () {
		$(this).toggleClass('active');
		$('body').toggleClass('no-scroll');
		$("#spnav").toggleClass('panelactive');
	});

	$("#spnav a").click(function () {
		$(".menubtn").removeClass('active');
		$('body').removeClass('no-scroll');
		$("#spnav").removeClass('panelactive');
	});
})


$(function () {
	$(".snav_cat a").click(function () {
		$(this).toggleClass('active');
		$('.snav_sub').toggleClass('show');
	});


})














// 動きのきっかけの起点となるアニメーションの名前を定義
function fadeAnime() {
	// ふわっ
	$('.fadeUpTrigger').each(function () { //fadeUpTriggerというクラス名が
		var elemPos = $(this).offset().top - 50; //要素より、50px上の
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight) {
			$(this).addClass('fadeUp'); // 画面内に入ったらfadeUpというクラス名を追記
		}
	});
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	fadeAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述



function fadeLeftAnime() {
	$('.fadeLeftTrigger').each(function () { //fadeUpTriggerというクラス名が
		var elemPos = $(this).offset().top - 50; //要素より、50px上の
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight) {
			$(this).addClass('fadeLeft'); // 画面内に入ったらfadeUpというクラス名を追記
		}
	});
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	fadeLeftAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述


function fadeRightAnime() {
	$('.fadeRightTrigger').each(function () { //fadeUpTriggerというクラス名が
		var elemPos = $(this).offset().top - 50; //要素より、50px上の
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight) {
			$(this).addClass('fadeRight'); // 画面内に入ったらfadeUpというクラス名を追記
		}
	});
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	fadeRightAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述




function delayScrollAnime() {
	var time = 0.1; //遅延時間を増やす秒数の値
	var value = time;
	$('.delayScroll').each(function () {
		var parent = this; //親要素を取得
		var elemPos = $(this).offset().top; //要素の位置まで来たら
		var scroll = $(window).scrollTop(); //スクロール値を取得
		var windowHeight = $(window).height(); //画面の高さを取得
		var childs = $(this).children(); //子要素を取得

		if (scroll >= elemPos - windowHeight && !$(parent).hasClass("play")) { //指定領域内にスクロールが入ったらまた親要素にクラスplayがなければ
			$(childs).each(function () {

				if (!$(this).hasClass("fadeUp")) { //アニメーションのクラス名が指定されているかどうかをチェック

					$(parent).addClass("play"); //親要素にクラス名playを追加
					$(this).css("animation-delay", value + "s"); //アニメーション遅延のCSS animation-delayを追加し
					$(this).addClass("fadeUp"); //アニメーションのクラス名を追加
					value = value + time; //delay時間を増加させる

					//全ての処理を終わったらplayを外す
					var index = $(childs).index(this);
					if ((childs.length - 1) == index) {
						$(parent).removeClass("play");
					}
				}
			})
		} else {
			$(childs).removeClass("fadeUp"); //アニメーションのクラス名を削除
			value = time; //delay初期値の数値に戻す
		}
	})
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	delayScrollAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述



const scrollThreshold = 400;

function FixedSubAnime() {
	const scroll = $(window).scrollTop();
	const $subNavi = $('.pages_sub_navi');

	if (scroll >= scrollThreshold) {
		$subNavi.addClass('UpMove');
		$subNavi.removeClass('DownMove');
	} else {
		$subNavi.addClass('DownMove');
		$subNavi.removeClass('UpMove');
	}
}

$(window).scroll(function () {
	FixedSubAnime();
});


$(function () {
	var topBtn = $('#page_scroll'),
		scrollHeight = $(document).height(),
		scrollPosition = $(window).height() + $(window).scrollTop();
	topBtn.hide();
	//スクロールが100に達したらボタン表示
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			topBtn.fadeIn();
		} else {
			topBtn.fadeOut();
		}
	});

	$(window).scroll(function () {
		var scrollHeight = $(document).height();
		var scrollPosition = $(window).height() + $(window).scrollTop();
		if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
			topBtn.toggleClass('last_scl');
		}
	});


	//スクロールしてトップ
	topBtn.click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 500);
		return false;
	});
});



//任意のタブにURLからリンクするための設定
function GethashID(hashIDName) {
	if (hashIDName) {
		$('.tab li').find('a').each(function () {
			var idName = $(this).attr('href');
			if (idName == hashIDName) {
				var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.tab li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
				$(parentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				$(".area").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
				$(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加 
			}
		});
	}
}


$('.tab a').on('click', function () {
	var idName = $(this).attr('href');
	GethashID(idName);
	return false;
});




//============================================
//	グローバルナビ　現在地
//============================================

$(function () {
	const url = location.href;
	const dir = url.split("/").filter(e => Boolean(e)); // URLを/で分割して配列に格納
	const lastDir = dir.pop(); // 分割したURLの最後の部分を取り出し
	const gNavs = document.querySelectorAll('.gnav_list ul li a');
	gNavs.forEach(gNav => {
		let currentName = gNav.className;
		if (lastDir === currentName) {
			gNav.classList.add('hilight');
		}
	});
});




const headerH = $("#header").outerHeight(true); //headerの高さを取得    


//スクロールすると上部に固定させるための設定を関数でまとめる
function FixedAnime() {
	var headerH = $('#header').outerHeight(true);
	var scroll = $(window).scrollTop();
	if (scroll >= headerH) { //headerの高さ以上になったら
		$('#header').addClass('fixed'); //fixedというクラス名を付与
	} else { //それ以外は
		$('#header').removeClass('fixed'); //fixedというクラス名を除去
	}
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	FixedAnime(); /* スクロール途中からヘッダーを出現させる関数を呼ぶ*/
});



$(function () {
	var footerfix = $('.footerfix');
	$(window).on('load scroll', function () {
		if ($(this).scrollTop() > 300) {
			footerfix.addClass('fixed');
		} else {
			footerfix.removeClass('fixed');
		}
	});
});



// new ScrollHint('.js-scrollable', {
// 	suggestiveShadow: true, //シャドウを追加
// 	i18n: {
// 		scrollable: 'スクロールできます'
// 	}
// });



// $(function () {
// 	$('.venobox').venobox({
// 		infinigall: true,
// 		numeratio: true,
// 	});
// });


var _getDevice = function () {
		var t = navigator.userAgent;
		return t.indexOf("iPhone") > 0 || t.indexOf("iPod") > 0 || t.indexOf("Android") > 0 && t.indexOf("Mobile") > 0 ? "mobile" : t.indexOf("iPad") > 0 || t.indexOf("Android") > 0 ? "tablet" : t.indexOf("Win") > 0 || t.indexOf("Mac") > 0 ? "pc" : "other"
	}(),
	_getIEVersion = function () {
		var t = window.navigator.userAgent.toLowerCase(),
			e = window.navigator.appVersion.toLowerCase();
		if (-1 != t.indexOf("msie")) {
			if (-1 != e.indexOf("msie 8.")) return "ie8";
			if (-1 != e.indexOf("msie 9.")) return "ie9";
			if (-1 != e.indexOf("msie 10.")) return "ie10"
		}
	}();

$(function () {
		"mobile" === _getDevice && ($(".locationMainHead_inner").length > 0 && $(".locationMainHead_inner").slick({
			autoplay: !0,
			arrows: !1,
			dots: !0,
			centerMode: !0,
			centerPadding: "15%"
		}), $(".rolexSection02Main_inner").length > 0 && $(".rolexSection02Main_inner").slick({
			slidesToShow: 2,
			slidesToScroll: 2,
			arrows: !1,
			dots: !0,
			infinite: !1
		}))
	}),


	function (t) {
		var e = -1,
			i = -1,
			n = function (t) {
				return parseFloat(t) || 0
			},
			a = function (e) {
				var i = null,
					a = [];
				return t(e).each(function () {
					var e = t(this),
						s = e.offset().top - n(e.css("margin-top")),
						o = 0 < a.length ? a[a.length - 1] : null;
					null === o ? a.push(e) : 1 >= Math.floor(Math.abs(i - s)) ? a[a.length - 1] = o.add(e) : a.push(e), i = s
				}), a
			},
			s = function (e) {
				var i = {
					byRow: !0,
					property: "height",
					target: null,
					remove: !1
				};
				return "object" == typeof e ? t.extend(i, e) : ("boolean" == typeof e ? i.byRow = e : "remove" === e && (i.remove = !0), i)
			},
			o = t.fn.matchHeight = function (e) {
				if ((e = s(e)).remove) {
					var i = this;
					return this.css(e.property, ""), t.each(o._groups, function (t, e) {
						e.elements = e.elements.not(i)
					}), this
				}
				return 1 >= this.length && !e.target || (o._groups.push({
					elements: this,
					options: e
				}), o._apply(this, e)), this
			};
		o._groups = [], o._throttle = 80, o._maintainScroll = !1, o._beforeUpdate = null, o._afterUpdate = null, o._apply = function (e, i) {
			var r = s(i),
				l = t(e),
				c = [l],
				h = t(window).scrollTop(),
				p = t("html").outerHeight(!0),
				d = l.parents().filter(":hidden");
			return d.each(function () {
				var e = t(this);
				e.data("style-cache", e.attr("style"))
			}), d.css("display", "block"), r.byRow && !r.target && (l.each(function () {
				var e = t(this),
					i = e.css("display");
				"inline-block" !== i && "inline-flex" !== i && (i = "block"), e.data("style-cache", e.attr("style")), e.css({
					display: i,
					"padding-top": "0",
					"padding-bottom": "0",
					"margin-top": "0",
					"margin-bottom": "0",
					"border-top-width": "0",
					"border-bottom-width": "0",
					height: "100px"
				})
			}), c = a(l), l.each(function () {
				var e = t(this);
				e.attr("style", e.data("style-cache") || "")
			})), t.each(c, function (e, i) {
				var a = t(i),
					s = 0;
				if (r.target) s = r.target.outerHeight(!1);
				else {
					if (r.byRow && 1 >= a.length) {
						a.css(r.property, "");
						return
					}
					a.each(function () {
						var e = t(this),
							i = e.css("display");
						"inline-block" !== i && "inline-flex" !== i && (i = "block"), (i = {
							display: i
						})[r.property] = "", e.css(i), e.outerHeight(!1) > s && (s = e.outerHeight(!1)), e.css("display", "")
					})
				}
				a.each(function () {
					var e = t(this),
						i = 0;
					r.target && e.is(r.target) || ("border-box" !== e.css("box-sizing") && (i += n(e.css("border-top-width")) + n(e.css("border-bottom-width")), i += n(e.css("padding-top")) + n(e.css("padding-bottom"))), e.css(r.property, s - i + "px"))
				})
			}), d.each(function () {
				var e = t(this);
				e.attr("style", e.data("style-cache") || null)
			}), o._maintainScroll && t(window).scrollTop(h / p * t("html").outerHeight(!0)), this
		}, o._applyDataApi = function () {
			var e = {};
			t("[data-match-height], [data-mh]").each(function () {
				var i = t(this),
					n = i.attr("data-mh") || i.attr("data-match-height");
				e[n] = n in e ? e[n].add(i) : i
			}), t.each(e, function () {
				this.matchHeight(!0)
			})
		};
		var r = function (e) {
			o._beforeUpdate && o._beforeUpdate(e, o._groups), t.each(o._groups, function () {
				o._apply(this.elements, this.options)
			}), o._afterUpdate && o._afterUpdate(e, o._groups)
		};
		o._update = function (n, a) {
			if (a && "resize" === a.type) {
				var s = t(window).width();
				if (s === e) return;
				e = s
			}
			n ? -1 === i && (i = setTimeout(function () {
				r(a), i = -1
			}, o._throttle)) : r(a)
		}, t(o._applyDataApi), t(window).bind("load", function (t) {
			o._update(!1, t)
		}), t(window).bind("resize orientationchange", function (t) {
			o._update(!0, t)
		})
	}(jQuery);